import { newCompany as TEXT } from 'locales/en';
import yup from 'utils/yupHelpers';
import { DEFAULT_COUNTRY } from 'utils/constants';
import { escapedCountryField } from 'utils/transform';

export const FIELD_NAMES = {
  legal_entity: 'legal_entity',
  mcc_code: 'mcc_code',
  legal_business_name: 'legal_business_name',

  first_name: 'first_name',
  last_name: 'last_name',
  contact_first_name: 'contact_first_name',
  contact_last_name: 'contact_last_name',
  store_name: 'store_name',
  country: escapedCountryField,
  email: 'email',
  phone_country: 'phone_country',
  phone_number: 'phone_number',
};

export const defaultValues = {
  [FIELD_NAMES.legal_entity]: null,
  [FIELD_NAMES.legal_business_name]: '',
  [FIELD_NAMES.store_name]: '',
  [FIELD_NAMES.first_name]: '',
  [FIELD_NAMES.last_name]: '',
  [FIELD_NAMES.country]: DEFAULT_COUNTRY,
};

const schema = yup.object().shape({
  [FIELD_NAMES.legal_entity]: yup
    .object()
    .nullable()
    .shape({
      name: yup.string(),
      value: yup.string(),
    })
    .required(TEXT.errors.legal_entity.required),

  [FIELD_NAMES.legal_business_name]: yup
    .string()
    .when(FIELD_NAMES.legal_entity, {
      is: (option) => option && option.value !== TEXT.types.individual,
      then: yup.string().required(TEXT.errors.legal_business_name.required),
    }),

  [FIELD_NAMES.first_name]: yup.string().when(FIELD_NAMES.legal_entity, {
    is: (option) => option && option.value === TEXT.types.individual,
    then: yup.string().required(TEXT.errors.first_name.required),
  }),
  [FIELD_NAMES.last_name]: yup.string().when(FIELD_NAMES.legal_entity, {
    is: (option) => option && option.value === TEXT.types.individual,
    then: yup.string().required(TEXT.errors.last_name.required),
  }),

  [FIELD_NAMES.store_name]: yup.string().when(FIELD_NAMES.legal_entity, {
    is: (option) => option !== null,
    then: yup.string().required(TEXT.errors.store_name.required),
  }),
  [FIELD_NAMES.mcc_code]: yup.object().shape({
    identifier: yup.string().required(TEXT.errors.industry.required),
  }),

  [FIELD_NAMES.country]: yup.object().shape({
    name: yup.string().required(TEXT.errors.country.required),
    dial_code: yup.string(),
    code: yup.string(),
  }),

  [FIELD_NAMES.contact_first_name]: yup
    .string()
    .required(TEXT.errors.first_name.required),
  [FIELD_NAMES.contact_last_name]: yup
    .string()
    .required(TEXT.errors.last_name.required),

  [FIELD_NAMES.email]: yup
    .string()
    .email(TEXT.errors.email.invalid)
    .required(TEXT.errors.email.required),
  [FIELD_NAMES.phone_number]: yup
    .string()
    .phoneNumber(TEXT.errors.phone_number.invalid)
    .required(TEXT.errors.phone_number.required),
});

export default schema;
